// src/components/customer/sidebar/CustomerSidebar.jsx
import React, { useState, useEffect, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  MdDeliveryDining,
  MdLocalShipping,
  MdAccountBalanceWallet,
  MdSupportAgent,
  MdNotifications,
  MdEmail,
  MdSettings,
  MdLogout,
} from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import MyContext from "../../../context/MyContext";
import "../../../assets/css/components/deliveryPanel/deliverySidebar/DeliverySidebar.css";

const DeliverySidebar = ({
  isCollapsed,
  setIsCollapsed,
  isMobileOpen,
  setIsMobileOpen,
  isMobile,
}) => {
  const navigate = useNavigate();
  const { baseUrl, authToken, loggedInDeliveryMan } = useContext(MyContext);

  // ── FIXED: pehle `useState(true)` se start hota tha — matlab har
  // dafa component mount hone par (jaise tab-switch karte waqt) turant
  // "🟢 Online" dikhta tha, phir viewProfile() ka response aane par
  // asal-status (jo "off" ho sakta hai) set hota tha — is darmiyan ek
  // visible flicker/flash hota tha (green → red). Ab `null` (matlab
  // "abhi pata nahi") se start karte hain aur jab tak asal-status na
  // aa jaye, toggle ko neutral/loading state mein rakhte hain — koi
  // galat-color kabhi flash nahi hoga.
  const [isAvailable, setIsAvailable] = useState(null);

  const viewProfile = () => {
    if (!loggedInDeliveryMan?.id || !authToken) return;
    axios
      .get(`${baseUrl}/delivery/profile/viewProfile`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (response.data.success) {
          setIsAvailable(
            (response.data.deliveryman?.availability_status || "").toLowerCase() === "on",
          );
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    viewProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInDeliveryMan?.id, baseUrl, authToken]);

  // ── NEW: agar OpenJobs page (ya kahi aur) se availability toggle ho,
  // to wahan se "delivery-availability-changed" event dispatch hota hai
  // — sidebar usay sun kar apna status refresh kar leta hai, taake
  // dono jagah turant sync rahein bina page reload ke ──
  useEffect(() => {
    const handler = () => viewProfile();
    window.addEventListener("delivery-availability-changed", handler);
    return () =>
      window.removeEventListener("delivery-availability-changed", handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInDeliveryMan?.id, baseUrl, authToken]);

  const logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#097d43",
      cancelButtonColor: "#dc3545",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("loggedInDeliveryMan");
        localStorage.removeItem("deliveryPhone");
        localStorage.removeItem("deliveryPassword");
        Swal.fire({
          title: "Logged Out!",
          text: "You have been logged out successfully.",
          icon: "success",
          confirmButtonColor: "#097d43",
          timer: 2000,
        }).then(() => navigate("/delivery/login"));
      }
    });
  };

  const availabilityStatus = (newStatus) => {
    setIsAvailable(newStatus);
    const formData = new FormData();
    formData.append("availability_status", newStatus ? "on" : "off");
    axios
      .post(`${baseUrl}/delivery/profile/availabilityStatus`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        if (!response.data.success) {
          setIsAvailable(!newStatus);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update availability.",
          });
        } else {
          // ── NEW: OpenJobs page ko batao ke status change ho gaya,
          // taake wo bhi apna profile/jobs refresh kar le ──
          window.dispatchEvent(new Event("delivery-availability-changed"));
        }
      })
      .catch((error) => {
        setIsAvailable(!newStatus);
        console.log(error);
      });
  };

  const handleNavClick = () => {
    if (isMobile) setIsMobileOpen(false);
  };

  const navItems = [
    { icon: MdLocalShipping, label: "Open Jobs", path: "/delivery/open-jobs" },
    { icon: MdDeliveryDining, label: "My Jobs", path: "/delivery/my-jobs" },
    {
      icon: MdAccountBalanceWallet,
      label: "Earnings",
      path: "/delivery/earnings",
    },
    {
      icon: MdSupportAgent,
      label: "Help & Support",
      path: "/delivery/support",
    },
    {
      icon: MdNotifications,
      label: "Notifications",
      path: "/delivery/notifications",
    },
    // { icon: MdEmail,               label: "Messages",       path: "/delivery/messages"      },
    { icon: MdSettings, label: "Settings", path: "/delivery/settings" },
  ];

  const sidebarClass = [
    "del-sidebar",
    isMobile ? "del-sidebar--mobile" : "",
    isMobile && isMobileOpen ? "del-sidebar--mobile-open" : "",
    !isMobile && isCollapsed ? "del-sidebar--collapsed" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const showLabel = isMobile ? true : !isCollapsed;

  return (
    <>
      {isMobile && isMobileOpen && (
        <div
          className="del-sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      <div className={sidebarClass}>
        {/* ── Logo ── */}
        <div
          className={`del-sidebar__logo ${!showLabel ? "del-sidebar__logo--centered" : ""}`}
        >
          <div className="del-sidebar__logo-icon">K</div>
          {showLabel && (
            <div className="del-sidebar__logo-text">
              <h4>Kisaan Mart</h4>
              <p>Delivery Panel</p>
            </div>
          )}
        </div>

        {/* ── Navigation ── */}
        <nav className="del-sidebar__nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <div key={item.path} className="del-sidebar__nav-item">
                <NavLink
                  to={item.path}
                  className="del-sidebar__nav-link"
                  onClick={handleNavClick}
                  title={!showLabel ? item.label : ""}
                >
                  <span className="del-sidebar__nav-icon">
                    <Icon />
                  </span>
                  {showLabel && (
                    <span className="del-sidebar__nav-label">{item.label}</span>
                  )}
                </NavLink>
              </div>
            );
          })}
        </nav>

        {/* ── Availability Toggle ──
             FIXED: jab tak isAvailable === null (asal-status abhi
             load ho raha hai), toggle ko ek neutral "loading" look
             dete hain — na green na red — taake koi galat-flash na ho. */}
        <div
          className={`del-sidebar__avail ${!showLabel ? "del-sidebar__avail--collapsed" : ""}`}
        >
          <div
            className={`del-avail-toggle ${
              isAvailable === null
                ? "del-avail-toggle--loading"
                : isAvailable
                ? "del-avail-toggle--on"
                : "del-avail-toggle--off"
            }`}
            onClick={() => {
              if (isAvailable === null) return; // asal-status load hone tak click ignore
              availabilityStatus(!isAvailable);
            }}
          >
            <div className="del-avail-toggle__knob" />
          </div>
          {showLabel && (
            <span
              className={`del-avail-label ${
                isAvailable === null
                  ? "del-avail-label--loading"
                  : isAvailable
                  ? "del-avail-label--online"
                  : "del-avail-label--offline"
              }`}
            >
              {isAvailable === null
                ? "⏳ Loading..."
                : isAvailable
                ? "🟢 Online"
                : "🔴 Offline"}
            </span>
          )}
        </div>

        {/* ── Logout ── */}
        <button
          className={`del-sidebar__logout ${!showLabel ? "del-sidebar__logout--icon-only" : ""}`}
          onClick={() => logout()}
        >
          <span className="del-sidebar__nav-icon">
            <MdLogout />
          </span>
          {showLabel && <span>Logout</span>}
        </button>
      </div>
    </>
  );
};

export default DeliverySidebar;